document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".header__store-menu").forEach((menu) => {
    let hideTimeout;

    menu.addEventListener("mouseenter", () => {
      if (hideTimeout) clearTimeout(hideTimeout);
    });

    menu.addEventListener("mouseleave", () => {
      hideTimeout = setTimeout(() => {
        if (menu.hasAttribute("open")) {
          menu.removeAttribute("open");
        }
      }, 150);
    });
  });
});
